module.exports = __webpack_public_path__ + "img/pic_subject_chinese.56f86113.png";